export default __webpack_public_path__ + "static/media/logo13.574f9875.svg";